/**
 * Widths and Heights of various components
 */
const headerHeight = "60px";
/**
 * ViewportSection
 */
const viewportSectionWidth = "100vh";
const viewportSectionHeight = "100vh";

/**
 * HighlightContainer
 */
const highlightContainerWidth = "900px";
const highlightContainerHeight = "525px";

/**
 * CarouselContainer
 */
const carouselContainerWidth = 500;
const carouselContainerHeight = 130;

/**
 * MediaServiceProviderBox
 */
const mediaServiceProviderBoxWidth = 190;
const mediaServiceProviderBoxHeight = 115;

/**
 * VideoResultContainer
 */
const videoResultContainerWidth = 792;

/**
 * VideoResultItemContainer
 */
const videoResultItemContainerWidth = 379;
const videoResultItemContainerHeight = 103;

/**
 * TranslucentInput
 */
const translucentInputWidth = 500;
const translucentInputHeight = 45;

/**
 * ServiceProviderLogo
 */
const serviceProviderLogoWidth = 122;

/**
 * Exports
 */
export {
  viewportSectionWidth,
  viewportSectionHeight,
  highlightContainerWidth,
  highlightContainerHeight,
  carouselContainerWidth,
  carouselContainerHeight,
  mediaServiceProviderBoxWidth,
  mediaServiceProviderBoxHeight,
  videoResultContainerWidth,
  videoResultItemContainerWidth,
  videoResultItemContainerHeight,
  translucentInputWidth,
  translucentInputHeight,
  serviceProviderLogoWidth,
  headerHeight
};
